import React, { FunctionComponent, ReactNode } from "react";

import ConfigContext, {
  AdConfig,
  AppConfig,
  CommentsConfig,
  MembershipConfig,
  NetworkConfig,
  CommunityConfig,
  CrossPostConfig,
  CoralConfig,
  CycloneConfig,
  NewslettersConfig,
  SeoConfig,
  ParselyConfig,
  PaywallConfig,
  SubscriptionProviderConfig,
  SubscriptionsConfig,
  FeatureConfig,
  StnVideoConfig,
  UserProfileConfig,
  WunderkindConfig,
  RetailerLinkOrderConfig,
} from "@context/context/config-context";
import { useGlobalDataContext } from "@context/context/global-data-context";

interface Props {
  adConfig: AdConfig;
  appConfig: AppConfig;
  commentsConfig: CommentsConfig;
  membershipConfig: MembershipConfig;
  networkConfig: NetworkConfig;
  communityConfig: CommunityConfig;
  crossPostConfig: CrossPostConfig;
  newslettersConfig: NewslettersConfig;
  coralConfig?: CoralConfig;
  customArticleFooter?: React.ReactNode;
  cycloneConfig: CycloneConfig;
  seoConfig: SeoConfig;
  parselyConfig: ParselyConfig;
  paywallConfig: PaywallConfig;
  stnVideoConfig?: StnVideoConfig;
  subscriptionProviderConfig?: SubscriptionProviderConfig;
  subscriptionsConfig?: SubscriptionsConfig;
  featureConfig: FeatureConfig;
  children?: ReactNode;
  userProfileConfig: UserProfileConfig;
  wunderkindConfig: WunderkindConfig;
  retailerLinkOrderConfig?: RetailerLinkOrderConfig;
}

const ConfigProvider: FunctionComponent<Props> = ({
  children,
  adConfig,
  appConfig,
  commentsConfig,
  membershipConfig,
  networkConfig,
  communityConfig,
  crossPostConfig,
  coralConfig,
  cycloneConfig,
  newslettersConfig,
  customArticleFooter,
  subscriptionProviderConfig,
  seoConfig,
  parselyConfig,
  paywallConfig,
  stnVideoConfig,
  subscriptionsConfig,
  featureConfig,
  userProfileConfig,
  wunderkindConfig,
  retailerLinkOrderConfig,
}) => {
  const {
    siteSettings: { siteDomain },
  } = useGlobalDataContext();

  const siteOrigin = `https://${siteDomain}`;

  return (
    <ConfigContext.Provider
      value={{
        adConfig,
        appConfig,
        commentsConfig,
        communityConfig: { ...communityConfig, siteOrigin },
        coralConfig,
        cycloneConfig,
        crossPostConfig,
        customArticleFooter,
        featureConfig,
        membershipConfig,
        networkConfig,
        newslettersConfig,
        seoConfig,
        parselyConfig,
        paywallConfig,
        stnVideoConfig,
        subscriptionProviderConfig,
        subscriptionsConfig,
        userProfileConfig,
        wunderkindConfig,
        retailerLinkOrderConfig,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;
